import { addClaimsType, editClaimsType } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      dataFrom: {
        name: '',
        sort: 0
      },
      continueVisible: false,
      continueState: false
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请至少输入名称')
        }],
        sort: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('paixu')
        }]
      };
    }
  },
  methods: {
    init(val, type) {
      if (val) {
        this.dataFrom = {
          claimsSortId: val.id,
          name: val.name,
          sort: val.sort
        };
      }
      if (!type) {
        this.continueVisible = true;
      }
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let fun = this.dataFrom.claimsSortId ? editClaimsType : addClaimsType;
          fun(this.dataFrom).then(res => {
            this.$message.success(this.$t('操作成功'));
            if (this.continueState) {
              this.$refs.dataFrom.resetFields();
            } else {
              this.$emit('cancel');
            }
            this.$emit('ok', res);
          });
        }
      });
    },
    onContinueToAdd() {
      this.continueState = !this.continueState;
      //
    }
  }
};